import { carouselList } from 'JBSrc/carousel';

jQuery($ => {
	carouselList();
});
